import React, { useMemo, useState } from 'react'

import { Button } from 'core-components/library/button/Button'
import { Controller, ValidationStatus } from 'core-components/library/validation'
import { InternationalPhoneInput } from 'dialer/components/widgets/public/phoneInput/InternationalPhoneInput'

import { ICallRequest } from '../../../../../classes/models/ICallRequest'
import { isNeedCorrectPhone } from '../../helpers/isNeedCorrectPhone'

import styles from './StatusView.module.scss'

interface IProps {
  message: string
  codes?: string[]
  lastCallRequest: ICallRequest
  call: (phone: string) => void
}

export const SimpleErrorView = ({ message, call, lastCallRequest }: IProps) => {
  const { call: callInfo } = lastCallRequest
  const { customerEndpoint } = callInfo || {}
  const [phone, setPhone] = useState(customerEndpoint)
  const [canSave, setCanSave] = useState(false)
  const showPhoneInput = useMemo(() => {
    return isNeedCorrectPhone(message)
  }, [message])

  const onCallClick = async (phone: string) => {
    call(phone)
  }

  return (
    <div className={styles.root}>
      <p>Something is not working as expected!</p>
      <p className={styles.mark__red}>{message}</p>
      {showPhoneInput ? (
        <div className={styles.recallWrapper}>
          <Controller
            onValidationStatusChange={(result) => {
              if (result.status === ValidationStatus.Valid) {
                setCanSave(true)
              } else if (result.status === ValidationStatus.Invalid) {
                setCanSave(false)
              }
            }}
          >
            <InternationalPhoneInput
              label={'Phone'}
              value={phone}
              onChange={setPhone}
              margin="md"
            />
          </Controller>
          <Button
            className={styles.recallWrapper__btn}
            onClick={() => onCallClick(phone)}
            disabled={!canSave}
          >
            Correct and Call
          </Button>
        </div>
      ) : null}
    </div>
  )
}
